/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef } from 'react'
import CurrentUserContext from "../../Contexts/userContexts";
import "./displayMessageDontAdd.css";
import { HiOutlineEmojiSad } from "react-icons/hi";

const DisplayMessageDontAdd = () => {
  const { playerSelectState, displayMessageDontAdd, setDisplayMessageDontAdd } = useContext(CurrentUserContext)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDisplayMessageDontAdd(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [playerSelectState]);


  let messageRef = useRef()
  useEffect(() => {
    const maybeHandler = (event) => {
      if (messageRef.current !== null && messageRef.current !== undefined && Object.keys(messageRef.current).length !== 0) {
        if (!messageRef.current.contains(event.target)) {
          setDisplayMessageDontAdd(false);
        }
      }
    }

    document.addEventListener("mousedown", maybeHandler);

    return () => {
      document.removeEventListener("mousedown", maybeHandler);
    };
  });

  return (
    <div className="displayContainerDontAdd" style={{ display: (displayMessageDontAdd ? "block" : "none") }} ref={messageRef}>
      <div className='displaymessagedontadd' >
        <div><HiOutlineEmojiSad style={{ transform: 'scale(2)' }} /></div>
        <div>{`${playerSelectState} is already part of your team!`}</div>
      </div>
    </div>
  )
}

export default DisplayMessageDontAdd;